import { VocabularyWord, Language, DifficultyLevel } from '../types';
import { storageService } from '../services/storageService';

// Vocabulary database organized by level and language
export const vocabularyDatabase: VocabularyWord[] = [
  // Level 1 - Very Easy (Simple everyday words)
  // English
  { id: 'en-1-cat', word: 'cat', language: 'en', level: 1, category: 'animals' },
  { id: 'en-1-dog', word: 'dog', language: 'en', level: 1, category: 'animals' },
  { id: 'en-1-sun', word: 'sun', language: 'en', level: 1, category: 'nature' },
  { id: 'en-1-red', word: 'red', language: 'en', level: 1, category: 'colors' },
  { id: 'en-1-blue', word: 'blue', language: 'en', level: 1, category: 'colors' },
  { id: 'en-1-tree', word: 'tree', language: 'en', level: 1, category: 'nature' },
  { id: 'en-1-ball', word: 'ball', language: 'en', level: 1, category: 'toys' },
  { id: 'en-1-book', word: 'book', language: 'en', level: 1, category: 'school' },

  // Spanish
  { id: 'es-1-gato', word: 'gato', language: 'es', level: 1, category: 'animals' },
  { id: 'es-1-perro', word: 'perro', language: 'es', level: 1, category: 'animals' },
  { id: 'es-1-sol', word: 'sol', language: 'es', level: 1, category: 'nature' },
  { id: 'es-1-rojo', word: 'rojo', language: 'es', level: 1, category: 'colors' },
  { id: 'es-1-azul', word: 'azul', language: 'es', level: 1, category: 'colors' },
  { id: 'es-1-casa', word: 'casa', language: 'es', level: 1, category: 'places' },
  { id: 'es-1-agua', word: 'agua', language: 'es', level: 1, category: 'food' },
  { id: 'es-1-niño', word: 'niño', language: 'es', level: 1, category: 'people' },

  // French
  { id: 'fr-1-chat', word: 'chat', language: 'fr', level: 1, category: 'animals' },
  { id: 'fr-1-chien', word: 'chien', language: 'fr', level: 1, category: 'animals' },
  { id: 'fr-1-lune', word: 'lune', language: 'fr', level: 1, category: 'nature' },
  { id: 'fr-1-bleu', word: 'bleu', language: 'fr', level: 1, category: 'colors' },
  { id: 'fr-1-rouge', word: 'rouge', language: 'fr', level: 1, category: 'colors' },
  { id: 'fr-1-pain', word: 'pain', language: 'fr', level: 1, category: 'food' },
  { id: 'fr-1-eau', word: 'eau', language: 'fr', level: 1, category: 'food' },
  { id: 'fr-1-fleur', word: 'fleur', language: 'fr', level: 1, category: 'nature' },

  // Level 2 - Easy (Common words)
  // English
  { id: 'en-2-happy', word: 'happy', language: 'en', level: 2, category: 'emotions' },
  { id: 'en-2-house', word: 'house', language: 'en', level: 2, category: 'places' },
  { id: 'en-2-water', word: 'water', language: 'en', level: 2, category: 'nature' },
  { id: 'en-2-friend', word: 'friend', language: 'en', level: 2, category: 'people' },
  { id: 'en-2-school', word: 'school', language: 'en', level: 2, category: 'places' },
  { id: 'en-2-pencil', word: 'pencil', language: 'en', level: 2, category: 'school' },
  { id: 'en-2-apple', word: 'apple', language: 'en', level: 2, category: 'food' },
  { id: 'en-2-green', word: 'green', language: 'en', level: 2, category: 'colors' },

  // Spanish
  { id: 'es-2-feliz', word: 'feliz', language: 'es', level: 2, category: 'emotions' },
  { id: 'es-2-madre', word: 'madre', language: 'es', level: 2, category: 'people' },
  { id: 'es-2-padre', word: 'padre', language: 'es', level: 2, category: 'people' },
  { id: 'es-2-verde', word: 'verde', language: 'es', level: 2, category: 'colors' },
  { id: 'es-2-coche', word: 'coche', language: 'es', level: 2, category: 'transport' },
  { id: 'es-2-mesa', word: 'mesa', language: 'es', level: 2, category: 'furniture' },
  { id: 'es-2-libro', word: 'libro', language: 'es', level: 2, category: 'school' },
  { id: 'es-2-leche', word: 'leche', language: 'es', level: 2, category: 'food' },

  // French
  { id: 'fr-2-heureux', word: 'heureux', language: 'fr', level: 2, category: 'emotions' },
  { id: 'fr-2-maison', word: 'maison', language: 'fr', level: 2, category: 'places' },
  { id: 'fr-2-vert', word: 'vert', language: 'fr', level: 2, category: 'colors' },
  { id: 'fr-2-livre', word: 'livre', language: 'fr', level: 2, category: 'school' },
  { id: 'fr-2-pomme', word: 'pomme', language: 'fr', level: 2, category: 'food' },
  { id: 'fr-2-table', word: 'table', language: 'fr', level: 2, category: 'furniture' },
  { id: 'fr-2-porte', word: 'porte', language: 'fr', level: 2, category: 'home' },
  { id: 'fr-2-jardin', word: 'jardin', language: 'fr', level: 2, category: 'nature' },

  // Level 3 - Medium (More complex words)
  // English
  { id: 'en-3-elephant', word: 'elephant', language: 'en', level: 3, category: 'animals' },
  { id: 'en-3-beautiful', word: 'beautiful', language: 'en', level: 3, category: 'adjectives' },
  { id: 'en-3-adventure', word: 'adventure', language: 'en', level: 3, category: 'activities' },
  { id: 'en-3-mountain', word: 'mountain', language: 'en', level: 3, category: 'nature' },
  { id: 'en-3-butterfly', word: 'butterfly', language: 'en', level: 3, category: 'animals' },
  { id: 'en-3-rainbow', word: 'rainbow', language: 'en', level: 3, category: 'nature' },
  { id: 'en-3-treasure', word: 'treasure', language: 'en', level: 3, category: 'objects' },
  { id: 'en-3-library', word: 'library', language: 'en', level: 3, category: 'places' },

  // Spanish
  { id: 'es-3-elefante', word: 'elefante', language: 'es', level: 3, category: 'animals' },
  { id: 'es-3-hermoso', word: 'hermoso', language: 'es', level: 3, category: 'adjectives' },
  { id: 'es-3-mariposa', word: 'mariposa', language: 'es', level: 3, category: 'animals' },
  { id: 'es-3-montaña', word: 'montaña', language: 'es', level: 3, category: 'nature' },
  { id: 'es-3-aventura', word: 'aventura', language: 'es', level: 3, category: 'activities' },
  { id: 'es-3-ventana', word: 'ventana', language: 'es', level: 3, category: 'home' },
  { id: 'es-3-estrella', word: 'estrella', language: 'es', level: 3, category: 'nature' },
  { id: 'es-3-familia', word: 'familia', language: 'es', level: 3, category: 'people' },

  // French
  { id: 'fr-3-éléphant', word: 'éléphant', language: 'fr', level: 3, category: 'animals' },
  { id: 'fr-3-papillon', word: 'papillon', language: 'fr', level: 3, category: 'animals' },
  { id: 'fr-3-montagne', word: 'montagne', language: 'fr', level: 3, category: 'nature' },
  { id: 'fr-3-aventure', word: 'aventure', language: 'fr', level: 3, category: 'activities' },
  { id: 'fr-3-fenêtre', word: 'fenêtre', language: 'fr', level: 3, category: 'home' },
  { id: 'fr-3-fromage', word: 'fromage', language: 'fr', level: 3, category: 'food' },
  { id: 'fr-3-famille', word: 'famille', language: 'fr', level: 3, category: 'people' },
  { id: 'fr-3-oiseau', word: 'oiseau', language: 'fr', level: 3, category: 'animals' },

  // Level 4 - Hard (Advanced vocabulary)
  // English
  { id: 'en-4-magnificent', word: 'magnificent', language: 'en', level: 4, category: 'adjectives' },
  { id: 'en-4-atmosphere', word: 'atmosphere', language: 'en', level: 4, category: 'science' },
  { id: 'en-4-interesting', word: 'interesting', language: 'en', level: 4, category: 'adjectives' },
  { id: 'en-4-photograph', word: 'photograph', language: 'en', level: 4, category: 'objects' },
  { id: 'en-4-mysterious', word: 'mysterious', language: 'en', level: 4, category: 'adjectives' },
  { id: 'en-4-telescope', word: 'telescope', language: 'en', level: 4, category: 'science' },
  { id: 'en-4-encyclopedia', word: 'encyclopedia', language: 'en', level: 4, category: 'school' },
  { id: 'en-4-extraordinary', word: 'extraordinary', language: 'en', level: 4, category: 'adjectives' },

  // Spanish
  { id: 'es-4-magnífico', word: 'magnífico', language: 'es', level: 4, category: 'adjectives' },
  { id: 'es-4-atmósfera', word: 'atmósfera', language: 'es', level: 4, category: 'science' },
  { id: 'es-4-interesante', word: 'interesante', language: 'es', level: 4, category: 'adjectives' },
  { id: 'es-4-fotografía', word: 'fotografía', language: 'es', level: 4, category: 'objects' },
  { id: 'es-4-misterioso', word: 'misterioso', language: 'es', level: 4, category: 'adjectives' },
  { id: 'es-4-telescopio', word: 'telescopio', language: 'es', level: 4, category: 'science' },
  { id: 'es-4-maravilloso', word: 'maravilloso', language: 'es', level: 4, category: 'adjectives' },
  { id: 'es-4-calendario', word: 'calendario', language: 'es', level: 4, category: 'objects' },

  // French
  { id: 'fr-4-magnifique', word: 'magnifique', language: 'fr', level: 4, category: 'adjectives' },
  { id: 'fr-4-atmosphère', word: 'atmosphère', language: 'fr', level: 4, category: 'science' },
  { id: 'fr-4-intéressant', word: 'intéressant', language: 'fr', level: 4, category: 'adjectives' },
  { id: 'fr-4-photographie', word: 'photographie', language: 'fr', level: 4, category: 'objects' },
  { id: 'fr-4-mystérieux', word: 'mystérieux', language: 'fr', level: 4, category: 'adjectives' },
  { id: 'fr-4-télescope', word: 'télescope', language: 'fr', level: 4, category: 'science' },
  { id: 'fr-4-merveilleux', word: 'merveilleux', language: 'fr', level: 4, category: 'adjectives' },
  { id: 'fr-4-bibliothèque', word: 'bibliothèque', language: 'fr', level: 4, category: 'places' },

  // Level 5 - Very Hard (Expert vocabulary)
  // English
  { id: 'en-5-phenomenal', word: 'phenomenal', language: 'en', level: 5, category: 'adjectives' },
  { id: 'en-5-philosophical', word: 'philosophical', language: 'en', level: 5, category: 'adjectives' },
  { id: 'en-5-archaeological', word: 'archaeological', language: 'en', level: 5, category: 'science' },
  { id: 'en-5-metamorphosis', word: 'metamorphosis', language: 'en', level: 5, category: 'science' },
  { id: 'en-5-kaleidoscope', word: 'kaleidoscope', language: 'en', level: 5, category: 'objects' },
  { id: 'en-5-sophisticated', word: 'sophisticated', language: 'en', level: 5, category: 'adjectives' },
  { id: 'en-5-onomatopoeia', word: 'onomatopoeia', language: 'en', level: 5, category: 'language' },
  { id: 'en-5-imagination', word: 'imagination', language: 'en', level: 5, category: 'concepts' },

  // Spanish
  { id: 'es-5-fenomenal', word: 'fenomenal', language: 'es', level: 5, category: 'adjectives' },
  { id: 'es-5-filosófico', word: 'filosófico', language: 'es', level: 5, category: 'adjectives' },
  { id: 'es-5-arqueológico', word: 'arqueológico', language: 'es', level: 5, category: 'science' },
  { id: 'es-5-metamorfosis', word: 'metamorfosis', language: 'es', level: 5, category: 'science' },
  { id: 'es-5-caleidoscopio', word: 'caleidoscopio', language: 'es', level: 5, category: 'objects' },
  { id: 'es-5-sofisticado', word: 'sofisticado', language: 'es', level: 5, category: 'adjectives' },
  { id: 'es-5-extraordinario', word: 'extraordinario', language: 'es', level: 5, category: 'adjectives' },
  { id: 'es-5-imaginación', word: 'imaginación', language: 'es', level: 5, category: 'concepts' },

  // French
  { id: 'fr-5-phénoménal', word: 'phénoménal', language: 'fr', level: 5, category: 'adjectives' },
  { id: 'fr-5-philosophique', word: 'philosophique', language: 'fr', level: 5, category: 'adjectives' },
  { id: 'fr-5-archéologique', word: 'archéologique', language: 'fr', level: 5, category: 'science' },
  { id: 'fr-5-métamorphose', word: 'métamorphose', language: 'fr', level: 5, category: 'science' },
  { id: 'fr-5-kaléidoscope', word: 'kaléidoscope', language: 'fr', level: 5, category: 'objects' },
  { id: 'fr-5-sophistiqué', word: 'sophistiqué', language: 'fr', level: 5, category: 'adjectives' },
  { id: 'fr-5-extraordinaire', word: 'extraordinaire', language: 'fr', level: 5, category: 'adjectives' },
  { id: 'fr-5-imagination', word: 'imagination', language: 'fr', level: 5, category: 'concepts' },
];

// Helper functions to work with vocabulary
export function getWordsByLevel(level: DifficultyLevel, language?: Language): VocabularyWord[] {
  // Get built-in vocabulary
  const builtIn = vocabularyDatabase.filter(
    (word) => word.level === level && (!language || word.language === language)
  );

  // Get custom vocabulary
  const custom = storageService.getCustomVocabulary().filter(
    (word) => word.level === level && (!language || word.language === language)
  );

  // Combine both
  return [...builtIn, ...custom];
}

export function getWordsByLanguage(language: Language): VocabularyWord[] {
  return vocabularyDatabase.filter((word) => word.language === language);
}

export function getRandomWords(
  count: number,
  level: DifficultyLevel,
  language: Language
): VocabularyWord[] {
  const availableWords = getWordsByLevel(level, language);
  const shuffled = [...availableWords].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, availableWords.length));
}

export function getWordById(id: string): VocabularyWord | undefined {
  return vocabularyDatabase.find((word) => word.id === id);
}

export const LANGUAGES: { code: Language; name: string; flag: string }[] = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Spanish', flag: '🇪🇸' },
  { code: 'fr', name: 'French', flag: '🇫🇷' },
  { code: 'de', name: 'German', flag: '🇩🇪' },
  { code: 'it', name: 'Italian', flag: '🇮🇹' },
  { code: 'pt', name: 'Portuguese', flag: '🇵🇹' },
  { code: 'nl', name: 'Dutch', flag: '🇳🇱' },
  { code: 'pl', name: 'Polish', flag: '🇵🇱' },
];
